import React from "react";
import DriverRevenue from "../DriverRevenue";

function DriverPage({ user }) {
  return <DriverRevenue user={user} />;
}

export default DriverPage;

